// extracted by mini-css-extract-plugin
module.exports = {"container":"no-attempts_container__GkSRz","cross-div":"no-attempts_cross-div__cIL3I","right":"no-attempts_right__9k5hc","btn-div":"no-attempts_btn-div__tnnBQ"};